import { List } from "immutable";
import React from "react";
import Select from "react-select";
import { FormField } from "./";
import { ContactTypes } from "../../domain";
import { PhoneNumberData } from "../../forms/generic";
import { Country } from "../../models/country";
import { SelectItem } from "../../models/editors";
import { ReactSelectOption } from "../../models/generic";
import { Utility } from "../../utils";
import { CountriesLoader } from "../reusable";
import { ValidatedFormFieldBase, ValidatedInput } from "../validation";

interface OwnProps {
    promptExtn?: boolean;
    hideType?: boolean;
}

interface OwnState {
    countries: List<Country>;
}

export class PhoneNumberField extends ValidatedFormFieldBase<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        this.state = {
            countries: List(),
        };
    }

    public render() {
        const label = this.getLabel(this.props.label);
        const value: PhoneNumberData | undefined = this.getValue() as PhoneNumberData;
        const countries = this.state.countries.toArray().map((c) => {
            return Utility.toReactSelectOption(c, c.name, c.isoCode);
        });
        const contactTypes: SelectItem[] = ContactTypes.Values.map((ct) => ({
            id: ct.id,
            selected: false,
            render: ct.name,
        }));

        const extnField = this.props.promptExtn
            ? [
                <p key={1} className="field-phone-x">&times;</p>,
                <p key={2} className="field-phone-ext">
                    <ValidatedInput
                        formComponent={this.props.formComponent}
                        type="text"
                        id={Utility.toHtmlIdString(this.props.name + ".extension")}
                        name={this.props.name + ".extension"}
                        css="txt"
                        placeholder="Ext."
                        title="Extension"
                        value={value ? (value.extension || "") : ""}
                    />
                </p>,
            ]
            : null;

        const typeField = this.props.hideType
            ? null
            : <ul className="options-h">
                {contactTypes.map((item, i) => {
                const checked = value && value.contactTypeId === item.id;
                return <li key={i}>
                    <label>
                        <input
                            type="radio"
                            name={this.props.name + ".contactTypeId"}
                            checked={checked}
                            value={item.id || ""}
                            onChange={() => {}}
                        /> {item.render}
                    </label>
                </li>;
            })}
            </ul>;

        return <div className="phone-field">
            <CountriesLoader onUpdated={(countryList) => this.setState({ ...this.state, countries: countryList })} />

            <FormField {...this.props} errors={this.getErrors()} label={label} name={this.props.name} required={this.isRequired(this.props.required)}>
                <div className={"field-single-line fields-phone-country" + (this.props.promptExtn ? "-extn" : "")}>
                    <div className="field-phone-country">
                        <Select
                            autosize={false}
                            clearable={false}
                            name={this.props.name}
                            options={countries}
                            onBlur={() => this.props.formComponent.triggerBlur(this.props.name + ".countryCode")}
                            onChange={(selectedValue: any) => this.props.formComponent.setFieldValue(this.props.name + ".countryCode", selectedValue)}
                            optionRenderer={(c: Country) => <span>{c.name} (+{c.phoneCode})</span>}
                            placeholder="Country code"
                            valueRenderer={(c: ReactSelectOption & Country) =>
                                c.value
                                    ? <span title={c.name}><img height="24" src={`https://restcountries.eu/data/${c.isoCode3.toLowerCase()}.svg`} /> (+{c.phoneCode})</span>
                                    : <span></span>
                            }
                            value={value ? (value.countryCode || "") : ""}
                        />
                    </div>
                    <p className="field-phone-number">
                        <ValidatedInput
                            formComponent={this.props.formComponent}
                            type="text"
                            id={Utility.toHtmlIdString(this.props.name + ".number")}
                            name={this.props.name + ".number"}
                            css="txt"
                            placeholder="Ex: 555-555-5555"
                            value={value ? (value.number || "") : ""}
                        />
                    </p>
                    {extnField}
                </div>

                {typeField}
            </FormField>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/editors/PhoneNumberField.tsx